import React, { useEffect, useMemo, useState } from 'react';
import RuntimeConfigGridToolbar from './RuntimeConfigGridToolbar';
import RuntimeConfigGridPagination from './RuntimeConfigGridPagination';
import { BROWSE_PAGE_SIZE } from './runtimeConfigUtils';

const FrameGrid = ({ document, onEdit, onRemove, disabled }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const patterns = document?.data?.patterns || [];

  useEffect(() => {
    setPage(0);
  }, [document]);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) {
      return patterns;
    }
    return patterns.filter((pattern) => pattern.toLowerCase().includes(term));
  }, [patterns, search]);

  const start = page * BROWSE_PAGE_SIZE;
  const pageRows = filtered.slice(start, start + BROWSE_PAGE_SIZE);

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(0);
  };

  if (!document) {
    return null;
  }

  return (
    <div className="runtime-config-grid-section" data-testid="frame-grid">
      <RuntimeConfigGridToolbar
        label="Filter frame patterns"
        placeholder="Search pattern…"
        value={search}
        onChange={handleSearchChange}
        testId="frame-search"
      />

      <table className="runtime-config-table">
        <thead>
          <tr>
            <th scope="col">Pattern</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pageRows.length === 0 ? (
            <tr>
              <td colSpan="2" className="runtime-config-empty">No frame patterns found.</td>
            </tr>
          ) : (
            pageRows.map((pattern) => (
              <tr key={pattern}>
                <td>{pattern}</td>
                <td>
                  <button
                    type="button"
                    className="runtime-config-row-btn"
                    disabled={disabled}
                    aria-label={`Edit frame pattern ${pattern}`}
                    onClick={() => onEdit({
                      isEdit: true,
                      editKey: pattern,
                      action: 'merge',
                      formState: { pattern },
                    })}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="runtime-config-row-btn runtime-config-row-btn-danger"
                    disabled={disabled}
                    aria-label={`Remove frame pattern ${pattern}`}
                    onClick={() => onRemove({ pattern })}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <RuntimeConfigGridPagination
        count={filtered.length}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default FrameGrid;
